import React from 'react';

export default function LoadingScreen() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center"
      style={{ background: 'linear-gradient(to bottom, #6C18C9, #9653E8, #CB9EF6)' }}
    >
      <style>{`
        @keyframes cscore-logo-pulse {
          0%, 100% { transform: scale(1); opacity: 0.95; }
          50% { transform: scale(1.04); opacity: 1; }
        }
        @keyframes cscore-bar-bounce {
          0%, 100% { transform: scaleY(0.35); }
          50% { transform: scaleY(1); }
        }
        .cscore-loading-logo {
          animation: cscore-logo-pulse 1.8s ease-in-out infinite;
        }
        .cscore-loading-bar {
          width: 8px;
          height: 36px;
          border-radius: 4px;
          background: #ffffff;
          transform-origin: center;
          animation: cscore-bar-bounce 1.1s ease-in-out infinite;
          box-shadow: 0 0 12px rgba(255,255,255,0.6);
        }
      `}</style>

      <img
        src="/cscore-logo.png"
        alt="CScore"
        className="cscore-loading-logo"
        style={{
          height: '48px',
          filter: 'brightness(0) invert(1)',
        }}
      />

      <div className="flex items-end gap-2 mt-8" style={{ height: '40px' }}>
        <div className="cscore-loading-bar" style={{ animationDelay: '0s' }} />
        <div className="cscore-loading-bar" style={{ animationDelay: '0.15s' }} />
        <div className="cscore-loading-bar" style={{ animationDelay: '0.3s' }} />
        <div className="cscore-loading-bar" style={{ animationDelay: '0.45s' }} />
        <div className="cscore-loading-bar" style={{ animationDelay: '0.6s' }} />
      </div>
    </div>
  );
}
